module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalHistoricoNotificacoes",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body alert-body"
  }, [_c('div', {
    staticClass: "filtro-historico-notificacoes"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filtrar pesquisa",
      "label-for": "filterInput",
      "align": "center"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticClass: "text-align-center",
    attrs: {
      "type": "search",
      "id": "filterInput",
      "placeholder": "Pesquise por qualquer palavra chave"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "limparPesquisaBotao",
    attrs: {
      "disabled": !_vm.filter,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Limpar pesquisa")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.historicoNotificacoes,
      "filter": _vm.filter,
      "fields": _vm.fieldsHistorico
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h1', {
    staticClass: "modal-title"
  }, [_vm._v("Histórico de Notificações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e296fa4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notificacao/modal/ModalHistoricoNotificacao.vue
// module id = 948
// module chunks = 1